import React from 'react';
import { Box, Text, Newline } from 'ink';
import { useTheme } from './lib/theme';

interface InfoMessageProps {
  message: string;
}

export const InfoMessage: React.FC<InfoMessageProps> = ({ message }) => {
  const { tokens } = useTheme();
  return (
    <Box flexDirection="column" marginY={0}>
      <Box paddingLeft={2}>
        <Text color={tokens.text.success}>{message}</Text>
      </Box>
      <Newline />
    </Box>
  );
};
